import photoConfig from 'ui-theme/widgets/axel-publication-content/js/config';

const config = photoConfig;
config.collapsible.textKeys = [];
config.collateral.permissions.removeCondition = "sessionStorage.getItem('accessType') === 'open'";
config.figures.all.linkToViewer.classList = '';
config.figures.all.linkToViewer.icon = 'ICON_IN_VIEWER_ALT';
config.figures.all.linkToViewer.text = 'remove';
config.figures.all.linkOpenAllinViewer.classList = 'btn btn--inverse px-4';
config.mobileBreakpoint = 1340;

export default config;
